import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconProtectComponent } from "./med-icon-protect.component";

@NgModule({
  declarations: [
    MedIconProtectComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconProtectComponent,
  ],
})
export class MedIconProtectModule { }
